import React from 'react'
import { checkTextTranslation, checkTranslation, getObject } from '../../utils/useful'

class TableMultiSelectInput extends React.Component {
    state = {
    }

    componentDidMount() {
        // console.log(this.props.header.key)
        // console.log(this.props.fullValues[this.props.header.key])
    }

    render() {
        let mainKey = this.props.header.key
        if (mainKey.includes('.')) {
            mainKey = mainKey.split('.')
            mainKey = mainKey[mainKey.length - 1]
        }

        // console.log('this.props.fullValuest', this.props.fullValues)
        // console.log('mainKeyt', mainKey)
        if (this.props.fullValues && this.props.fullValues[mainKey] && !Array.isArray(this.props.fullValues[mainKey])) {
            // console.log('this.props.fullValues[mainKey]',this.props.fullValues[mainKey])
            return (
                <div className="w-100 h-100 flexcc px-2">

                    <div className={'flexcc w-100'} style={{ flexWrap: 'wrap' }}>

                        <p className="text-smaller" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'nowrap' }}>{checkTranslation(getObject(this.props.fullValues[mainKey], this.props.header?.information?.fields?.title))}</p>

                    </div>

                </div>
            )

        } else {

            return (
                <div className="w-100 h-100 flexcc px-2">

                    {this.props.data && Array.isArray(this.props.data) && (
                        <div className={'flexcc'} style={{ flexWrap: 'wrap' }}>
                            {/* {console.log('this.props.datasss',this.props.data)} */}
                            {this.props.data.map((prop, index) => {
                                return (
                                    <div key={index} className="mx-1 mb-1" style={{ cursor: 'pointer', backgroundColor: '#f2f6f8', borderRadius: 4, padding: '2px 6px' }}>
                                        <p className="text-smaller" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', whiteSpace: 'nowrap' }}>{prop ? (typeof prop == 'object' ? checkTranslation(getObject(prop, this.props.header?.information?.fields?.title)) : prop) : ' '}</p>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </div>
            )
        }
    }
}

export default TableMultiSelectInput;